import { FlexBox } from "@components/wrapper"
import clsx from "clsx"
import React from "react"
import { useController } from "react-hook-form"
import { FormInputProps } from "."

export function PhoneInput({ control, name, label, placeHolder }: FormInputProps) {
  const { field, fieldState } = useController({ name, control })
  const { error } = fieldState

  function handleKeyDown(e: React.KeyboardEvent<HTMLInputElement>) {
    const keyPressed = e.key
    const ALLOWED_KEY = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Backspace"]

    if (!ALLOWED_KEY.includes(keyPressed)) {
      e.preventDefault()
    }
  }

  return (
    <div className="w-full">
      <label className="text-gray-8e sm:text-sm text-xxs">{label} </label>
      <FlexBox
        className={clsx(
          "relative border-b  sm:p-2 py-2 w-full gap-2",
          error ? "border-red" : "border-gray-8e"
        )}
      >
        <div className="sm-only:text-xs">+62</div>
        <input
          onKeyDown={handleKeyDown}
          {...field}
          placeholder={placeHolder}
          className={clsx("focus:outline-0 w-full sm-only:text-xs", error && "text-red")}
          type="tel"
        />
      </FlexBox>
      <small className="text-red">{error?.message}</small>
    </div>
  )
}
